/**
 * The `beforeLoad` gate every "Ship and Debit Admin" page shares: the Ship &
 * Debit module and SDAdmin.Read. (The route's `access` block stays inline,
 * where the route-rbac lint reads it.)
 */

import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import type { RouterContext } from 'src/pages/__root';
import { requireModules, requirePermission } from '../route';

/** Route `beforeLoad`: redirects unless the viewer is an S&D admin. */
export async function requireSdAdmin({
  context,
}: {
  context: RouterContext;
}): Promise<void> {
  requireModules({ context, oneOf: [ProductModule.SHIP_AND_DEBIT] });
  await requirePermission({
    context,
    action: Action.Read,
    subject: Subject.SDAdmin,
  });
}
